import { createRouter, createWebHistory } from 'vue-router';
import terminalsRoutes from './terminalsRoutes';

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: () => import('@/views/Dashboard/DashboardMainView.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                permitAll: true,
                bc: [{ text: 'breadCrumb.home', to: { name: 'dashboard' } }],
            },
        },
        {
            path: '/notifications',
            name: 'notifications',
            component: () =>
                import('@/views/Notifications/NotificationsIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                permitAll: true,
                bc: [
                    {
                        text: 'breadCrumb.notifications',
                        to: { name: 'notifications' },
                    },
                ],
            },
        },

        {
            path: '/machines',
            name: 'machines',
            component: () => import('@/views/Machines/MachinesIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                bc: [{ text: 'breadCrumb.machines', to: { name: 'machines' } }],
            },
        },
        {
            path: '/machines/top10',
            name: 'machinesTop10',
            component: () => import('@/views/Machines/Top10/Top-10.vue'),
            meta: {
                currentAccessName: 'machines',
                bc: [{ text: 'breadCrumb.machines', to: { name: 'machines' } }],
            },
        },
        {
            path: '/machines/:id',
            name: 'machines.show',
            component: () => import('@/views/Machines/MachinesShow.vue'),
            meta: {
                bc: [
                    { text: 'breadCrumb.machines', to: { name: 'machines' } },
                    { key: ':id', to: { name: 'machines.show' } },
                ],
            },
        },
        {
            path: '/tools',
            name: 'tools',
            component: () => import('@/views/Tools/ToolsIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                bc: [{ text: 'breadCrumb.tools', to: { name: 'tools' } }],
            },
        },
        {
            path: '/tools/:id',
            name: 'tools.show',
            component: () => import('@/views/Tools/ToolsShow.vue'),
            meta: {
                bc: [
                    { text: 'breadCrumb.tools', to: { name: 'tools' } },
                    { key: ':id', to: { name: 'tools.show' } },
                ],
            },
        },
        {
            path: '/issues',
            name: 'issues',
            component: () => import('@/views/Issues/IssuesIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                bc: [{ text: 'breadCrumb.issues', to: { name: 'issues' } }],
            },
        },
        {
            path: '/notes',
            name: 'notes',
            component: () => import('@/views/Notes/NotesView.vue'),
            meta: { bc: [{ text: 'breadCrumb.notes', to: { name: 'notes' } }] },
        },
        {
            path: '/changes_suggestions',
            name: 'changeSuggestions.index',
            component: () =>
                import('@/views/ChangeSuggestions/ChangeSuggestionsIndex.vue'),
            meta: {
                permitAll: true,
                bc: [
                    {
                        text: 'common.changeSuggestions',
                        to: { name: 'changeSuggestions.index' },
                    },
                ],
            },
        },
        {
            path: '/issue/:id',
            name: 'issues.show',
            component: () => import('@/views/Issues/IssueShow.vue'),
            meta: {
                bc: [
                    { text: 'breadCrumb.issues', to: { name: 'issues' } },
                    { key: ':id', to: { name: 'issues.show' } },
                ],
            },
        },
        {
            path: '/timetable',
            name: 'timetable',
            component: () => import('@/views/Maintenance/MaintenanceIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                bc: [
                    {
                        text: 'breadCrumb.maintenance',
                        to: { name: 'timetable' },
                    },
                ],
            },
        },

        {
            path: '/parts',
            name: 'parts',
            component: () => import('@/views/Parts/PartsIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                bc: [{ text: 'breadCrumb.parts', to: { name: 'parts' } }],
            },
        },
        {
            path: '/parts/:id',
            name: 'parts.show',
            component: () => import('@/views/Parts/PartsShow.vue'),
            meta: {
                bc: [
                    { text: 'breadCrumb.parts', to: { name: 'parts' } },
                    { key: ':id', to: { name: 'parts.show' } },
                ],
            },
        },

        {
            path: '/parts/:id/entry/:entryId',
            name: 'parts.entries.show',
            component: () => import('@/views/PartEntry/PartEntryShow.vue'),
            meta: {
                currentAccessName: 'parts.details.edit',
                bc: [
                    { text: 'breadCrumb.parts', to: { name: 'parts' } },
                    { key: ':partId', to: { name: 'parts.show' } },
                    { text: 'parts.partEntry', disabled: true },
                    { key: ':id', to: { name: 'parts.entries.show' } },
                ],
            },
        },

        {
            path: '/storage/:id?',
            name: 'storage',
            component: () => import('@/views/Storage/StorageIndex.vue'),
            meta: {
                bc: [],
            },
        },
        {
            path: '/reports',
            name: 'reports',
            component: () => import('@/views/Reports/ReportsIndex.vue'),
            meta: {
                permitAll: true,
                bc: [
                    {
                        text: 'reports.reports',
                        to: { name: 'reports' },
                    },
                ],
            },
        },
        {
            path: '/counters',
            name: 'counters',
            component: () => import('@/views/Counters/CountersIndex.vue'),
            meta: {
                currentAccessName: 'counters',
                bc: [
                    {
                        text: 'common.counters',
                        to: { name: 'counters' },
                    },
                ],
            },
        },

        {
            path: '/settings/locations/:id?',
            name: 'settings.locations',
            component: () => import('signalo-vue-settings-locations-view'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.locations',
                        to: { name: 'settings.locations' },
                    },
                ],
            },
        },
        {
            path: '/settings/equipment-states/:id?',
            name: 'settings.equipment_states',
            component: () =>
                import(
                    '@/views/settings/EquipmentStates/EquipmentStatesIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.equipmentStates',
                        to: { name: 'settings.equipment_states' },
                    },
                ],
            },
        },
        {
            path: '/settings/work-order-templates',
            name: 'settings.work_order_templates',
            component: () =>
                import(
                    '@/views/settings/WorkOrderTemplates/WorkOrderTemplatesIndex.vue'
                ),
            meta: {
                currentAccessName: 'work_order_templates',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.workOrderTemplates',
                        to: { name: 'settings.work_order_templates' },
                    },
                ],
            },
        },
        {
            path: '/settings/dictionary/:id?',
            name: 'settings.dictionary',
            component: () => import('signalo-vue-settings-dictionaries-view'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.dictionary',
                        to: { name: 'settings.dictionary' },
                    },
                ],
            },
        },
        {
            path: '/settings/categories/:id?',
            name: 'settings.categories',
            component: () =>
                import('@/views/settings/Categories/CategoriesView.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.categories',
                        to: {
                            name: 'settings.categories',
                        },
                        disabled: true,
                        href: '#',
                    },
                ],
            },
        },
        {
            path: '/settings/categories/:id/parameters',
            name: 'settings.categories-parameters',
            component: () =>
                import('@/views/settings/Parameters/ParametersView.vue'),
            meta: {
                currentAccessName: 'settings.categories',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.categories',
                        to: { name: 'settings.categories' },
                    },
                    { key: ':id', to: { name: 'settings.categories' } },
                    {
                        text: 'breadCrumb.parameters',
                        to: { name: 'settings.categories-parameters' },
                    },
                ],
            },
        },
        {
            path: '/settings/cost-centers',
            name: 'settings.cost-centers',
            component: () =>
                import('@/views/settings/CostCenters/CostCentersView.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.costCenter',
                        to: { name: 'settings.cost-centers' },
                    },
                ],
            },
        },
        {
            path: '/settings/work-schemas',
            name: 'settings.work-schemas',
            component: () =>
                import('@/views/settings/WorkSchemas/WorkSchemasIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.workSchemas',
                        to: { name: 'settings.work-schemas' },
                    },
                ],
            },
        },
        {
            path: '/settings/shifts-schemas',
            name: 'settings.shifts-schemas',
            component: () =>
                import('@/views/settings/Shifts/ShiftsSchemasView.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.shiftSchemas',
                        to: { name: 'settings.shifts-schemas' },
                    },
                ],
            },
        },
        {
            path: '/settings/shifts-schemas/:id',
            name: 'settings.shifts-schemas.show',
            component: () => import('@/views/settings/Shifts/ShiftsView.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.shiftSchemas',
                        to: { name: 'settings.shifts-schemas' },
                    },
                    {
                        text: 'breadCrumb.shifts',
                        to: { name: 'settings.shifts-schemas.show' },
                    },
                ],
            },
        },
        {
            path: '/settings/equipment_types',
            name: 'settings.equipment-types',
            component: () =>
                import(
                    '@/views/settings/EquipmentTypes/EquipmentTypesIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.definitionsOfMachinesAndToolsTypes',
                        to: { name: 'settings.equipment-types' },
                    },
                ],
            },
        },
        {
            path: '/settings/equipment_types/create',
            name: 'settings.equipment-types.create',
            component: () =>
                import(
                    '@/views/settings/EquipmentTypes/EquipmentTypesCreate.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.definitionsOfMachinesAndToolsTypes',
                        to: { name: 'settings.equipment-types' },
                    },
                    {
                        text: 'breadCrumb.add',
                        to: { name: 'settings.equipment-types.create' },
                    },
                ],
            },
        },
        {
            path: '/settings/equipment_types/:id/edit',
            name: 'settings.equipment-types.edit',
            component: () =>
                import(
                    '@/views/settings/EquipmentTypes/EquipmentTypesEdit.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'breadCrumb.definitionsOfMachinesAndToolsTypes',
                        to: { name: 'settings.equipment-types' },
                    },
                    {
                        key: ':id',
                        to: {
                            name: 'settings.equipment-types.edit',
                            disabled: true,
                            href: '#',
                        },
                    },
                    {
                        text: 'breadCrumb.edit',
                        to: { name: 'settings.equipment-types.edit' },
                    },
                ],
            },
        },
        {
            path: '/settings/company-management',
            name: 'settings.companyManagement',
            component: () =>
                import(
                    '@/views/settings/CompanyManagement/CompanyManagementIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.companyData',
                        to: { name: 'settings.companyManagement' },
                    },
                ],
            },
        },
        {
            path: '/terminals',
            name: 'terminals',
            component: () =>
                import('@/views/settings/Terminals/TerminalsIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.terminals',
                        to: { name: 'terminals' },
                    },
                ],
            },
        },
        {
            path: '/terminals/:id/equipment',
            name: 'settings.terminalEquipment',
            component: () =>
                import(
                    '@/views/settings/Terminals/TerminalsEquipmentIndex.vue'
                ),
            meta: {
                currentAccessName: 'terminals.edit',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.terminals',
                        to: { name: 'terminals' },
                    },
                    {
                        text: 'common.assignedEquipment',
                        to: { name: 'settings.terminalEquipment' },
                    },
                ],
            },
        },
        {
            path: '/settings/synchronization',
            name: 'settings.synchronization',
            component: () =>
                import(
                    '@/views/settings/Synchronization/SynchronizationIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.synchronization',
                        to: { name: 'settings.synchronization' },
                    },
                ],
            },
        },
        {
            path: '/settings/synchronization/imports',
            name: 'settings.synchronization.parts-import',
            component: () =>
                import(
                    '@/views/settings/Synchronization/Import/SynchronizationImportsIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.synchronization',
                        to: { name: 'settings.synchronization' },
                    },
                    {
                        text: 'common.synchronizationImport',
                        to: { name: 'settings.synchronization.parts-import' },
                    },
                ],
            },
        },
        {
            path: '/settings/synchronization/exports',
            name: 'settings.synchronization.parts-export',
            component: () =>
                import(
                    '@/views/settings/Synchronization/Export/SynchronizationExportsIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.synchronization',
                        to: { name: 'settings.synchronization' },
                    },
                    {
                        text: 'common.synchronizationExport',
                        to: { name: 'settings.synchronization.parts-export' },
                    },
                ],
            },
        },

        {
            path: '/settings/issues',
            name: 'settings.issues',
            component: () => import('@/views/settings/Issues/IssuesIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'issues.issues',
                        to: { name: 'settings.issues' },
                    },
                ],
            },
        },
        {
            path: '/settings/issues/responsible_rules',
            name: 'settings.issues.responsible-rules',
            component: () =>
                import(
                    '@/views/settings/Issues/IssueResponsibleRules/IssueResponsibleRulesIndex.vue'
                ),
            meta: {
                currentAccessName: 'settings.issues.edit',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'issues.issues',
                        to: { name: 'settings.issues' },
                    },
                    {
                        text: 'issues.responsibleRules',
                        to: { name: 'settings.issues.responsible-rules' },
                    },
                ],
            },
        },
        {
            path: '/settings/issues/limits',
            name: 'settings.issues.limits',
            component: () =>
                import(
                    '@/views/settings/Issues/IssuesLimits/IssuesLimitsIndex.vue'
                ),
            meta: {
                currentAccessName: 'settings.issues.edit',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'issues.issues',
                        to: { name: 'settings.issues' },
                    },
                    {
                        text: 'common.issuesLimits',
                        to: { name: 'settings.issues.limits' },
                    },
                ],
            },
        },
        {
            path: '/job-statuses',
            name: 'jobStatusses',
            component: () =>
                import('@/views/Processes/JobStatusses/JobStatussesIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                currentAccessName: 'process',
                bc: [
                    {
                        text: 'common.jobStatusses',
                        to: { name: 'jobStatusses' },
                    },
                ],
            },
        },
        {
            path: '/job-statuses/:id',
            name: 'jobStatusses.show',
            component: () =>
                import('@/views/Processes/JobStatusses/JobStatusPreview.vue'),
            meta: {
                currentAccessName: 'process',
                bc: [
                    {
                        text: 'common.jobStatusses',
                        to: { name: 'jobStatusses' },
                    },
                    { key: ':id', to: { name: 'jobStatusses.show' } },
                ],
            },
        },
        {
            path: '/staff',
            name: 'staff',
            component: () => import('@/views/Staff/StaffIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                bc: [{ text: 'breadCrumb.staff', to: { name: 'staff' } }],
            },
        },
        {
            path: '/staff/:id',
            name: 'staff.show',
            component: () => import('@/views/Staff/StaffShow.vue'),
            meta: {
                bc: [
                    { text: 'breadCrumb.staff', to: { name: 'staff' } },
                    { key: ':id' },
                ],
            },
        },
        {
            path: '/staff/:id/tags',
            name: 'staff.tags',
            component: () => import('@/views/Tags/TagsIndex.vue'),
            meta: {
                currentAccessName: 'staff.edit',
                bc: [
                    { text: 'breadCrumb.staff', to: { name: 'staff' } },
                    { key: ':id', to: { name: 'staff.show' } },
                    { text: 'common.tags' },
                ],
            },
        },
        {
            path: '/crews',
            name: 'settings.crews',
            component: () => import('@/views/settings/Crews/CrewsIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.crews',
                        to: { name: 'settings.crews' },
                    },
                ],
            },
        },
        {
            path: '/settings/user_templates',
            name: 'settings.userProfiles',
            component: () =>
                import('@/views/settings/UserTemplates/UserTemplatesIndex.vue'),
            meta: {
                currentAccessName: 'settings.staff',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.staffProfiles',
                        to: { name: 'settings.userProfiles' },
                    },
                ],
            },
        },
        {
            path: '/settings/user_templates/:id/notification_preferences',
            name: 'settings.userProfilesNotificationPreferences',
            component: () =>
                import(
                    '@/views/settings/UserTemplates/UserTemplateNotificationsPreferences.vue'
                ),
            meta: {
                currentAccessName: 'settings.staff',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.staffProfiles',
                        to: { name: 'settings.userProfiles' },
                    },
                    {
                        key: ':id',
                    },
                    {
                        text: 'common.notificationsManagement',
                        to: {
                            name: 'settings.userProfilesNotificationPreferences',
                        },
                    },
                ],
            },
        },
        {
            path: '/settings/user_templates/:id/groups',
            name: 'settings.userProfilesGroups',
            component: () =>
                import('@/views/settings/UserTemplates/UserTemplateGroups.vue'),
            meta: {
                currentAccessName: 'settings.staff',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.staffProfiles',
                        to: { name: 'settings.userProfiles' },
                    },
                    {
                        key: ':id',
                    },
                    {
                        text: 'common.groups',
                        to: { name: 'settings.userProfilesGroups' },
                    },
                ],
            },
        },
        {
            path: '/external_systems',
            name: 'settings.systems',
            component: () =>
                import(
                    '@/views/settings/ExternalSystems/ExternalSystemsIndex.vue'
                ),
            meta: {
                currentAccessName: 'settings.systems',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.externalSystems',
                        to: { name: 'settings.systems' },
                    },
                ],
            },
        },
        {
            path: '/settings/meters-settings',
            name: 'settings.meters-settings',
            component: () =>
                import('@/views/settings/Meters/MetersSettings.vue'),
            meta: {
                currentAccessName: 'settings.counters',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.metersSettings',
                        to: { name: 'settings.meters-settings' },
                    },
                ],
            },
        },
        {
            path: '/settings/meters',
            name: 'settings.meters',
            component: () => import('@/views/settings/Meters/MetersIndex.vue'),
            meta: {
                currentAccessName: 'settings.counters',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.metersSettings',
                        to: { name: 'settings.meters-settings' },
                    },
                    {
                        text: 'common.meters',
                        to: { name: 'settings.meters' },
                    },
                ],
            },
        },
        {
            path: '/settings/meters-countable-fields',
            name: 'settings.meters-countable-fields',
            component: () =>
                import('@/views/settings/Meters/MetersCountableFields.vue'),
            meta: {
                currentAccessName: 'settings.counters',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.metersSettings',
                        to: { name: 'settings.meters-settings' },
                    },
                    {
                        text: 'common.countableFields',
                        to: { name: 'settings.meters-countable-fields' },
                    },
                ],
            },
        },
        {
            path: '/settings/indexes',
            name: 'settings.indexes',
            component: () =>
                import('@/views/settings/Indexes/IndexesIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.indexes',
                        to: { name: 'settings.indexes' },
                    },
                ],
            },
        },
        {
            path: '/settings/indexes/:id/entries',
            name: 'settings.indexes.entries',
            component: () =>
                import(
                    '@/views/settings/Indexes/IndexEntries/IndexEntriesIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.indexes',
                        to: { name: 'settings.indexes' },
                    },
                    { key: ':index', to: { name: 'settings.indexes' } },
                    {
                        text: 'tableHeaders.entries',
                        to: { name: 'settings.indexes.entries' },
                    },
                ],
            },
        },
        {
            path: '/watch',
            name: 'watch',
            component: () => import('@/views/Supervision/SupervisionIndex.vue'),
            meta: {
                availableAsTerminalDefaultView: true,
                bc: [
                    {
                        text: 'navDrawer.supervision',
                        to: { name: 'watch' },
                    },
                ],
            },
        },

        {
            path: '/my-profile',
            name: 'my_profile',
            component: () => import('@/views/MyProfile/MyProfile.vue'),
            meta: {
                permitAll: true,
                bc: [
                    {
                        text: 'breadCrumb.myProfile',
                        to: { name: 'my_profile' },
                    },
                ],
            },
        },
        {
            path: '/me/issue_history',
            name: 'me.issues.history',
            component: () =>
                import('@/views/MyProfile/Issues/IssueHistory.vue'),
            meta: {
                permitAll: true,
                bc: [
                    {
                        text: 'breadCrumb.myProfile',
                        to: { name: 'my_profile' },
                    },
                    {
                        text: 'breadCrumb.me.issue_history',
                        disabled: true,
                        href: '#',
                    },
                ],
            },
        },

        // {
        //     path: '/products',
        //     name: 'settings.products',
        //     component: () =>
        //         import('@/views/temp/ProductsIndex.vue'),
        //     meta: {
        //         currentAccessName: 'products',
        //         bc: [
        //             {
        //                 text: 'breadCrumb.configuration',
        //                 to: { name: 'settings' },
        //             },
        //             {
        //                 text: 'common.products',
        //                 to: { name: 'settings.products' },
        //             },
        //         ],
        //     },
        // },
        {
            path: '/production-monitor',
            name: 'production_monitor',
            component: () =>
                import('@/views/ProductionMonitor/ProductionMonitor.vue'),
            meta: {
                permitAll: true, //czy mamy uprawnienie do production monitor
                availableAsTerminalDefaultView: true,
                bc: [
                    {
                        text: 'common.productionMonitor',
                        to: { name: 'production_monitor' },
                    },
                ],
            },
        },
        {
            path: '/settings/plants',
            name: 'settings.plants',
            component: () => import('@/views/settings/Plants/PlantsIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.plants',
                        to: { name: 'settings.plants' },
                    },
                ],
            },
        },
        {
            path: '/settings/plants/:id/buildings',
            name: 'settings.buildings',
            component: () =>
                import('@/views/settings/Plants/Buildings/BuildingsIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.plants',
                        to: { name: 'settings.plants' },
                    },
                    {
                        key: ':id',
                        to: { name: 'settings.plants' },
                    },
                    {
                        text: 'common.buildings',
                        to: { name: 'settings.buildings' },
                    },
                ],
            },
        },
        {
            path: '/settings/plants/:id/buildings/:bid/floors',
            name: 'settings.floors',
            component: () =>
                import(
                    '@/views/settings/Plants/Buildings/Floors/FloorsIndex.vue'
                ),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.plants',
                        to: { name: 'settings.plants' },
                    },
                    {
                        key: ':id',
                        to: { name: 'settings.plants' },
                    },
                    {
                        text: 'common.buildings',
                        to: { name: 'settings.buildings' },
                    },
                    {
                        key: ':bid',
                        to: { name: 'settings.buildings' },
                    },
                    {
                        text: 'common.floors',
                        to: { name: 'settings.floors' },
                    },
                ],
            },
        },
        {
            path: '/settings/plants/:id/buildings/:bid/floors/:fid/map',
            name: 'settings.floor_map',
            component: () =>
                import('@/views/settings/Plants/Buildings/Floors/FloorMap.vue'),
            meta: {
                currentAccessName: 'settings.floors',
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.plants',
                        to: { name: 'settings.plants' },
                    },
                    {
                        key: ':id',
                        to: { name: 'settings.plants' },
                    },
                    {
                        text: 'common.buildings',
                        to: { name: 'settings.buildings' },
                    },
                    {
                        key: ':bid',
                        to: { name: 'settings.buildings' },
                    },
                    {
                        text: 'common.floors',
                        to: { name: 'settings.floors' },
                    },
                    {
                        key: ':fid',
                        to: { name: 'settings.floors' },
                    },
                    {
                        text: 'common.map',
                        to: { name: 'settings.floor_map' },
                    },
                ],
            },
        },
        {
            path: '/settings/flags',
            name: 'settings.flags',
            component: () => import('@/views/settings/Flags/FlagsIndex.vue'),
            meta: {
                bc: [
                    {
                        text: 'breadCrumb.configuration',
                        to: { name: 'settings' },
                    },
                    {
                        text: 'common.flags',
                        to: { name: 'settings.flags' },
                    },
                ],
            },
        },
        // {
        //     //TODO LIBA
        //     path: '/settings/dictionary/:id/values/:vid/parameters',
        //     name: 'settings.dictionary-value-parameters',
        //     component: () =>
        //         import('@/views/settings/Parameters/ParametersView.vue'),
        //     meta: {
        //         currentAccessName: 'settings.dictionary',
        //         bc: [
        //             {
        //                 text: 'breadCrumb.configuration',
        //                 to: { name: 'settings' },
        //             },
        //             {
        //                 text: 'breadCrumb.dictionary',
        //                 to: { name: 'settings.dictionary' },
        //             },
        //             { key: ':id', to: { name: 'settings.dictionary' } },
        //             {
        //                 text: 'common.value',
        //             },
        //             { key: ':vid', to: { name: 'settings.dictionary' } },
        //             {
        //                 text: 'breadCrumb.parameters',
        //                 to: { name: 'settings.dictionary-value-parameters' },
        //             },
        //         ],
        //     },
        // },
        ...terminalsRoutes,
        {
            path: '/error',
            name: 'error',
            component: () => import('@/components/global/PageError.vue'),
            meta: {
                permitAll: true,
            },
        },

        {
            path: '/:pathMatch(.*)*',
            name: 'not-found',
            component: () => import('@/components/global/PageNotFound.vue'),
            meta: {
                permitAll: true,
            },
        },
        /*
      {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    },
    */
    ],
});

export default router;
